<div class="search-site" walkThroughStep="search" [class.agency-header]="isAgency">
  <mc-search-input
    #searchInput
    (focusEvent)="openTooltip()"
    (blurEvent)="blurInput($event)"
    [formControl]="searchSiteName"
    [placeholder]="placeholder"
  >
  </mc-search-input>
  <div class="tooltip-panel-wrapper" [class.hidden]="!showTooltip">
    <mc-tooltip-panel-wrapper>
      <mc-tooltip-panel [forceOpen]="showTooltip" [position]="'bottom-right'">
        <div class="tooltip-body" [ngClass]="{loading: loading}">
          @if (loading) {
            <mc-progress-spinner class="loader"></mc-progress-spinner>
          } @else {
            <div class="sites">
              @if (searchValue.length && searchString) {
                <mc-site-list
                  [sites]="searchValue"
                  (addNewSite)="openAddSitesDrawer($event)"
                  (manageSite)="closeTooltip($event)"
                  (goToAllSites)="closeTooltip($event)"
                  (goToEmbedCode)="closeTooltip($event)"
                  (lastElementBlur)="blurInput($event)"
                ></mc-site-list>
              }
              @if (!searchValue.length && searchString) {
                <div class="sites-row">
                  <span
                    data-testid="header.right-side.no-sites-found.site-name"
                    class="site-name"
                    [title]="searchString"
                    >{{ searchString }}</span
                  >
                  <div class="btn-row">
                    <mc-button
                      class="btn-row-item"
                      size="small"
                      variant="flat"
                      color="secondary"
                      (click)="redirectToInspector()"
                      data-testid="header.right-side.no-sites-found.inspect"
                    >
                      Inspect
                    </mc-button>

                    <mc-button
                      *permissionGuard="UserPermissions.manageSites.addSiteService"
                      (click)="openAddSitesDrawer($event)"
                      class="btn-row-item"
                      size="small"
                      variant="flat"
                      color="primary"
                      data-testid="header.right-side.no-sites-found.add-sites-button"
                    >
                      + Add Site
                    </mc-button>
                  </div>
                </div>
              }
              @if (!searchString) {
                <mc-site-list
                  [sites]="latestSites"
                  [showHead]="true"
                  (addNewSite)="openAddSitesDrawer($event)"
                  (manageSite)="closeTooltip($event)"
                  (goToAllSites)="closeTooltip($event)"
                  (lastElementBlur)="blurInput($event)"
                ></mc-site-list>
              }
            </div>
          }
        </div>
      </mc-tooltip-panel>
    </mc-tooltip-panel-wrapper>
  </div>
</div>
